import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IGenerateSocialVideoV1Response } from './generate-social-video-v1-response';
import { generateSocialVideoV1ResponseSchema } from './generate-social-video-v1-response';

export async function generateSocialVideoV1Api(
  challengeId: number,
  clipIds?: number[],
): Promise<IValidatedResponse<IGenerateSocialVideoV1Response>> {
  return postRequest<IGenerateSocialVideoV1Response>({
    path: `/sys/social/v1/challenges/${challengeId}/generate`,
    body: clipIds ? { clipIds } : undefined,
    schema: generateSocialVideoV1ResponseSchema,
  });
}
